module.exports = __webpack_public_path__ + "static/img/equipamiento-six-2.587a766.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/equipamiento-six-2.jpg
// module id = VtrN
// module chunks = 1